import React from "react";
import { FrameItem } from "../QrFrameItems";
import QrFrameWrapper from "../QrFrameWrapper";
import { Col, Row } from "react-bootstrap";
import useFrames from "../../../../../hooks/useFrames";
import useWindowSize from "../../../../../hooks/useWindowSize";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { setActivePremadeTemplateId } from "../../../../../redux/slices/preMadeTemplates";
import { qrResetSettings } from "../../../../../redux/slices/qrSettings";
import PalleteIcon from "./svg/PalleteIcon";

function FrameCategoryBlock({
  title,
  categories,
  isStandart,
  handleViewMore,
  setFrame,
  setFrameTransform,
  setFrameTransformText,
  frame,
}) {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.frame,
  }));
  const { frameConfigs, framesCategories } = useFrames();
  const { isDesktop } = useWindowSize();
  const dispatch = useDispatch();

  const indexes = Object.keys(categories)
    .map((category) => framesCategories.indexOf(category))
    .filter((index) => index !== -1);

  const categoryCount = frameConfigs.filter((item) =>
    indexes.includes(item.categoryId)
  ).length;

  const countMore = isDesktop
    ? categoryCount > 5
      ? categoryCount - 5
      : 0
    : categoryCount > 2
    ? categoryCount - 2
    : 0;

  return (
    <>
      <div className="mb-2 mb-lg-3 fw-bold fs-6 fs-lg-8 d-flex align-items-baseline">
        {title}

        {isStandart && (
          <OverlayTrigger
            overlay={
              <Tooltip id="tooltip-standart-frames" className="opacity-75">
                {lang[16]}
              </Tooltip>
            }
          >
            <div>
              <PalleteIcon className="ms-2 fs-7 mb-1" />
            </div>
          </OverlayTrigger>
        )}
      </div>
      <Row className="g-cards">
        {frameConfigs
          .filter((item) => indexes.includes(item.categoryId))
          .slice(0, isDesktop ? 5 : 2)
          .map((i) => {
            return (
              <Col xs={4} key={i.id}>
                <FrameItem
                  onClick={() => {
                    dispatch(qrResetSettings());
                    setFrame(i.name);
                    setFrameTransform(i.transformQr);
                    setFrameTransformText(i.transformFrameText);
                    dispatch(setActivePremadeTemplateId(null));
                  }}
                  className={classNames(
                    "d-flex justify-content-center align-items-center border rounded-1 p-2 h-100",
                    {
                      "border-primary": i.name === frame,
                      "border-border-gray": i.name !== frame,
                    }
                  )}
                >
                  <QrFrameWrapper
                    frame={i.name}
                    frameColor={"#727271"}
                    isTransformFrameWithTextTemplate={false}
                  />
                </FrameItem>
              </Col>
            );
          })}

        {countMore > 0 && (
          <Col xs={4}>
            <FrameItem
              className="d-flex justify-content-center align-items-center border rounded-1 p-2 h-100 flex-column fs-4 py-4 cursor-pointer"
              onClick={() => {
                handleViewMore(Object.keys(categories)[0]);
              }}
            >
              +{countMore}
            </FrameItem>
          </Col>
        )}
      </Row>
    </>
  );
}

export default FrameCategoryBlock;
